const PENDING_INVITATION_KEY = 'community:pending-room-invitation:v1';
const INVITATION_PARAMETERS = ['community_invite', 'room_invite'] as const;
const TOKEN_PATTERN = /^[a-f0-9]{64}$/i;

export function normalizeInvitationToken(value: unknown): string {
  const token = typeof value === 'string' ? value.trim().toLowerCase() : '';
  return TOKEN_PATTERN.test(token) ? token : '';
}

export function invitationTokenFromSearch(search: string): string {
  const parameters = new URLSearchParams(search);
  for (const name of INVITATION_PARAMETERS) {
    const token = normalizeInvitationToken(parameters.get(name));
    if (token) return token;
  }
  return '';
}

export function communityInvitationUrl(
  token: string,
  origin = 'https://community.katrinundrayk.de',
): string {
  const normalized = normalizeInvitationToken(token);
  if (!normalized) throw new Error('Der Einladungslink ist ungültig.');
  const url = new URL('/', origin);
  url.searchParams.set('community_invite', normalized);
  return url.toString();
}

export function rememberInvitationToken(token: string): string {
  const normalized = normalizeInvitationToken(token);
  if (!normalized) return '';
  sessionStorage.setItem(PENDING_INVITATION_KEY, normalized);
  return normalized;
}

export function pendingInvitationToken(search = window.location.search): string {
  const fromUrl = invitationTokenFromSearch(search);
  if (fromUrl) return rememberInvitationToken(fromUrl);
  return normalizeInvitationToken(sessionStorage.getItem(PENDING_INVITATION_KEY));
}

export function clearPendingInvitationToken(): void {
  sessionStorage.removeItem(PENDING_INVITATION_KEY);
  const url = new URL(window.location.href);
  for (const name of INVITATION_PARAMETERS) url.searchParams.delete(name);
  window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}` || '/');
}

export function invitationMailto(args: {
  email: string;
  roomTitle: string;
  inviteUrl: string;
}): string {
  const subject = `Deine persönliche Einladung · ${args.roomTitle}`;
  const body = [
    'Hallo,',
    '',
    `hier ist deine persönliche Einladung in den geschützten Raum „${args.roomTitle}“:`,
    '',
    args.inviteUrl,
    '',
    'Öffne den Link und melde dich mit deinem bestehenden persönlichen Zugang an.',
    'Beim allerersten Zugang brauchst du zusätzlich den allgemeinen Einladungscode. Danach wird der Raum automatisch für dich freigeschaltet.',
    '',
    'Herzlich',
    'Katrin & Rayk',
  ].join('\n');
  return `mailto:${encodeURIComponent(args.email)}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}
